import React, { JSX } from 'react';
import Cookies from 'js-cookie';
import { trackErrorEvent, trackMessageEvent } from '../../utils/AnalyticsUtils';
import { ERRORMESSAGE, ERRORTYPE, FIXNET } from '../../Analytics/AnalyticsConstants';
import { viewport } from '../../utils/utils';
import ToolTip from '../ToolTip/ToolTip';
import Styles from './Success.module.scss';

interface successInterface {
  content: string | JSX.Element;
  isLoading: boolean;
  uploadDownload: MaxDownloadUploadSpeed | Partial<MaxDownloadUploadSpeed>;
  textContent: any;
  eligibleBundle: any;
  tooltipcontent: string | JSX.Element;
  onSuccess?: any;
  isAvailable:boolean;
}
interface MaxDownloadUploadSpeed {
  maxBandwidthDown: number;
  maxBandwidthUp: number;
}

const Success = ({
  content,
  uploadDownload,
  textContent,
  eligibleBundle,
  tooltipcontent,
  onSuccess,
  isAvailable
}: successInterface): JSX.Element => {
  const viewPort = viewport();
  let accessType: any = typeof window != 'undefined' && Cookies.get('one-commerce-access-type');
  const linecheckContent = textContent?.linecheck?.[0];
  try {
    accessType = accessType && JSON.parse(accessType);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('invalid access Type json');
  }
  const [errorMessage, setErrorMessage] = React.useState<string>();
  React.useEffect(() => {
    if (eligibleBundle?.length < 1 || !isAvailable) {
      setErrorMessage(linecheckContent?.dataText);
    } else {
      setErrorMessage('');
    }
  }, []);

  const otherProductClick = () => {
    if (textContent?.otherProductsUrl?.url && typeof window != 'undefined') {
      window.location.href = textContent?.otherProductsUrl?.url;
    }
  };

  const createCart = () => {
    typeof onSuccess === 'function' && onSuccess();
  };

  //tracking linkcheck error message
  React.useEffect(() => {
    errorMessage &&
      trackMessageEvent(
        errorMessage,
        FIXNET + ' ' + linecheckContent?.title,
        ERRORMESSAGE,
        ERRORTYPE
      );
    errorMessage &&
      trackErrorEvent(
        ERRORTYPE,
        ERRORMESSAGE,
        FIXNET + ' | ' + linecheckContent?.title,
        errorMessage
      );
  }, [errorMessage]);

  return (
    <>
      <div
        className={`${Styles['addresstext']} ${
          viewPort != 'mobile' &&
          (eligibleBundle && (errorMessage || !errorMessage) && eligibleBundle?.length > 1 && isAvailable
            ? Styles['addresstext']
            : Styles['address-unsuccess'])
        }`}
      >
        <span>{content}</span>
        <div className={Styles['speed']}>
          {!errorMessage && linecheckContent?.maximumSpeedText && (
            <p className={Styles['maxspeed']}>{linecheckContent?.maximumSpeedText}</p>
          )}
          {!errorMessage && (
            <span className={Styles['tooltip']}>
              {tooltipcontent && (
                <ToolTip content={tooltipcontent} />
              )}
            </span>
          )}
        </div>
        {!errorMessage && eligibleBundle?.length > 0 && isAvailable && (
          <div className={Styles['networkInfo']}>
            <div className={Styles['mobilecard']}>
              <div className={Styles['mobilerow']}>
                <div className={Styles['spacedownload']}>
                  <span className={Styles['downloadText']}>
                    {<>{linecheckContent?.downloadText}</>}
                  </span>
                  <span className={Styles['downloader']}>
                    <b className={Styles['download']}>{uploadDownload?.maxBandwidthDown}</b>
                  </span>
                </div>
              </div>
              <div className={Styles['mobilerow']}>
                <div className={Styles['spaceupload']}>
                  <span className={Styles['uploadText']}>
                    {<>{linecheckContent?.uploadText}</>}
                  </span>

                  <span>
                    <b className={Styles['upload']}>{uploadDownload?.maxBandwidthUp}</b>
                  </span>
                </div>{' '}
                &nbsp;&nbsp;
              </div>
            </div>
          </div>
        )}
      </div>

      {!errorMessage && eligibleBundle?.length > 0 && isAvailable && (
        <div className={Styles['checkout']}>
          <button
            name='check address button'
            type='button'
            className={`primarybutton ${Styles['checks-click']}`}
            disabled={false}
            onClick={createCart}
          >
            {textContent?.checkoutButtonLabel}
            <span>
              <img
                src={linecheckContent?.rightArrowWhiteIcon?.filename}
                height={24}
                width={24}
                alt='right-arrow'
                className={Styles['checkoutline']}
              />
            </span>
          </button>
        </div>
      )}

      {errorMessage && !isAvailable && (
        <div className={Styles['product']}>
          <button
            name='check address button'
            type='button'
            className={Styles['secondarybutton']}
            disabled={false}
            onClick={otherProductClick}
          >
            {textContent?.otherProductsLabel}
            <span>
              <img
                src={linecheckContent?.arrowIcon?.filename}
                height={24}
                width={24}
                alt='right-arrow'
                className={Styles['checkoutline']}
              />
            </span>
          </button>
        </div>
      )}
    </>
  );
};

export default Success;
